import { Modal } from "antd";
import Web3 from "web3";
import React from "react";
import "../../assets/css/calendar.css"
import { contractCall, getContacts, getEventCollection } from "../../helper/web3helper";
import { X, Trash2 } from 'lucide-react';
import web3Config from "../../web3/web3Config.json";
import contactABI from "../../web3/contactContract.json";
import { toast } from "react-toastify";
import { transactionAction } from "../../helper/chain-helper";
import { logo } from "../../assets/svg/svg";
import { reportError, toErrorString } from "../../utils/errorLogger";
const Contact = (params) => {
    const [checkBox, setCheckBox] = React.useState()
    const [contacts, setContacts] = React.useState([]);
    const [visible, setVisible] = React.useState([])
    const [boxShadow, setboxShadow] = React.useState(false);
    const [labels, setLabels] = React.useState([]);
    const [labelName, setLabelName] = React.useState("All Contacts")
    const handleref = React.useRef();
    const [filteredContacts, setFilteredContacts] = React.useState([])
    const userName = localStorage.getItem('UserName');
    const handleClickOutside = (event) => {
        if (handleref.current && !handleref.current.contains(event.target)) {
            setboxShadow(false)
        }
    }

    React.useEffect(() => {
        document.addEventListener("click", handleClickOutside);
        return (() => {
            document.removeEventListener("click", handleClickOutside);
        })
    }, [])
    React.useEffect(() => {
        handleContactsList()
    }, [params.userName])

    const isValidEmail = (email) => {
        const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
        return emailRegex.test(email);
    };

    const handleContactsList = async () => {
        try {
            const formattedContactsList = await getEventCollection();
            const data = formattedContactsList?.data || [];

            const filterContacts = data
                .filter((contact) =>
                    !contact.attributes.some((attr) => attr.key === 'isDeleted' && attr.value === 'true')
                )
                .map((contact) => {
                    const emailAttrs = contact.attributes.filter(
                        (attr) => attr.key.startsWith("email") && isValidEmail(attr.value)
                    );
                    const validEmail = emailAttrs.length > 0 ? emailAttrs[0].value : null;

                    return validEmail
                        ? {
                            ...contact,
                            email: validEmail,
                        }
                        : null; // Mark for filtering
                })
                .filter(Boolean); // Remove null contacts (no valid email)

            setContacts(filterContacts);
            setFilteredContacts(filterContacts);
            setLabels(labels);
            setLabelName("All Contacts");
        } catch (error) {
            const errorStr = toErrorString(error || error.message);
            reportError({
                endpoint: '-',
                message: `FileName: Contacts.js, Fun: handleContactsList, ${String(error.message || 'Unhandled error')}`,
                error: errorStr,
                level: 'warn',
                userName: userName || '',
            });
            console.error('Error fetching contacts or labels:', error);
        }
    };

    const handleCheckBox = (id) => {
        setVisible((prev) => {
            const result = prev.includes(id);
            const value = result ? prev.filter((item) => item !== id) : [...prev, id];
            return value;
        })
    }

    const handleInsert = () => {
        const typeMap = {
            to: {
                key: "torecipent",
                update: params.to
            },
            cc: {
                key: "ccrecipent",
                update: params.cc
            },
            bcc: {
                key: "bccrecipent",
                update: params.bcc
            }
        };

        const typeData = typeMap[params.type];
        if (!typeData) return;

        const currentValue = params[typeData.key] ? params[typeData.key].split(",").filter(Boolean) : [];
        const availableSlots = 250 - currentValue.length;

        const filteredContacts = contacts
            .filter((data, index) => index < availableSlots && visible.includes(data.contactId))
            .map(data => data.email);

        const uniqueNewEmails = [...new Set(filteredContacts)];

        typeData.update(prev => {
            const combined = [...currentValue, ...uniqueNewEmails];
            const uniqueCombined = [...new Set(combined)];
            return uniqueCombined.join(",");
        });

        params.close();

        if (visible.length > 250 && !toast.isActive("duplicateError")) {
            toast.info("You can Add only 250 contacts", {
                toastId: "duplicateError",
                position: "top-center",
            });
        }
    };

    const handleFilter = (e) => {
        const value = e.target.value.toLowerCase()
        const filteredContacts = contacts.filter(contact => contact.name.toLowerCase().includes(value))
        setFilteredContacts(filteredContacts)
    }
    const handleOptions = (e) => {
        if (e.target.value === 'allcontacts') {
            setFilteredContacts(contacts)
            setLabelName("All Contacts")
            return
        }
        const response = labels.filter((item, index) => index.toString() === e.target.value && item.id.toString())
        setLabelName(response[0].name)
        const result = response[0]?.labelProperties.map(data => {
            return data.key === "contact_ids" && data.value.split(",").length > 0 ? data.value.split(",") : [data.value]
        }).flat();
        const finalResponse = contacts.filter(data => {
            return result.includes(data.contactId.toString())
        })
        setFilteredContacts(finalResponse)

    }
    const handleSelectAll = () => {
        if (visible.length === filteredContacts.length) {
            setVisible([]);
        }
        else {
            setVisible(filteredContacts.map((data) => data.contactId));
        }
    }
    const handleDelete = async (name) => {
        const value = labels.map(item => item.name === name && item.id).filter(Boolean)
        const web3 = new Web3(web3Config?.CHAIN_DETAILS?.rpcUrls[0]);
        const contractValue = contractCall(contactABI.contract, web3Config.CONTACT_CONTRACT);
        const walletAddress = localStorage.getItem("walletAddress");
        try {
            params.loader(true)
            const functionParams = [[value], params.userName];
            const hash = await transactionAction(
                contractValue,
                "deleteLabels",
                functionParams,
                walletAddress,
                "contact"
            );
            if (!hash) {
                toast.error("Something went wrong", {
                    id: "Something-went-wrong-delete-label",
                });
                return;
            }
            toast.success("Label deleted successfully");

        } catch (error) {
            const errorStr = toErrorString(error || error.message);
            reportError({
                endpoint: '-',
                message: `FileName: Contacts.js, Fun: handleDelete, ${String(error.message || 'Unhandled error')}`,
                error: errorStr,
                userName: userName || '',
            });
            toast.error("Something went wrong.", {
                id: "Something-went-wrong-delete-label",
            });
            console.error(error);
        } finally {
            handleContactsList()
            params.loader(false)
        }
    }
    return (
        <>

            <Modal
                className="modal-loader-contacts"
                open={true}
                onOk={params.close} onCancel={params.close}
                footer={null}
            >   <div>


                    <div className="main_div">
                        <div className="header_contacts">
                            <img src="/app/Dcontacts.png" alt="dcontacts" width={30} />
                            <p>Select Contacts</p>
                        </div>
                        <div className="inputfield" ref={handleref} onClick={() => {
                            setboxShadow(true)
                        }}>
                            <input placeholder="Search for contacts" type="text" className={`serach ${boxShadow ? "boxShadow" : ""}`} onChange={handleFilter} />
                        </div>
                    </div>

                    <div className="checkbox_header">
                        <div className="checbox_maindiv">
                            <input type="checkbox" className="checkbox" onClick={handleSelectAll} checked={filteredContacts.length === visible.length && filteredContacts.length !== 0 ? true : false} />
                            <p>Select All</p>
                        </div>
                        <div></div>
                        <div className="selectBox" onChange={(e) => handleOptions(e)}>
                            <select className="select_options">
                                <option value="allcontacts">All Contacts</option>
                                {labels.length > 0 && labels.map((data, index) =>
                                    <option value={index} key={index}>{data.name}</option>)}
                            </select>

                        </div>

                    </div>
                    <hr className="horizontal_line"></hr>
                    <div className={`all_contacts ${visible.length > 0 ? "height" : ""} scroll`} >
                        <p className="title">{`${labelName} (${filteredContacts.length})`}   {labelName !== "All Contacts" && <span onClick={(e) => handleDelete(labelName)}><Trash2 /></span>}</p>
                        {filteredContacts.length > 0 ?
                            <>
                                {filteredContacts.length > 0 && filteredContacts.map((data, index) =>
                                    <div key={index} className="clickable-flex" onMouseEnter={() => setCheckBox(index)} onMouseLeave={() => setCheckBox()} onClick={(e) => handleCheckBox(data.contactId)}>
                                        {checkBox !== index && !visible.includes(data.contactId) && <p className="profile_pic">{(data.name[0] ? data.name[0] : data.name[1]) || '#'}</p>}
                                        {(checkBox === index || visible.includes(data.contactId)) && <input type="checkbox" className="checkbox" checked={visible.includes(data.contactId)} />}
                                        <p className="flex-grow-1 m-0 fs-5">{data.name}</p>
                                        <p className="flex-text-ellipsis">{data.email}</p>
                                    </div>
                                )}</>
                            :
                            <div className='no-message-div'>
                                <div className='search-icon-no-message'> {logo.svg_mag_glass} </div>
                                <div className='no-message-yet-ele'>There are no contacts for this user.</div>
                            </div>}
                    </div>
                    {visible.length > 0 && <div className="insert_div">
                        <div className="insert_main_div">
                            <p> <span onClick={() => { setVisible([]) }}><X /></span>    {visible.length} Selected</p>
                            <div className="button_div">
                                <button className="btn btn-primary" onClick={() => handleInsert()}>Insert</button>
                            </div>
                        </div>
                    </div>}




                </div >
            </Modal >

        </>)
}

export default Contact;